/**
 * @fileoverview Provides utility functions for tokenizing strings. Includes the `tokenCount` function, which uses 'js-tiktoken' to count tokens in a string.
 */

import { getEncoding } from 'js-tiktoken'

export function tokenCount(contents: string): number {
  contents = contents.replace(/<\|endoftext\|>/g, 'endoftext')
  return getEncoding('cl100k_base').encode(contents).length
}
